import { render } from "./PacienteSelect.vue?vue&type=template&id=19cba056"
import script from "./PacienteSelect.vue?vue&type=script&lang=js"
export * from "./PacienteSelect.vue?vue&type=script&lang=js"

import "../assets/base.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__